import { STD_PROCESS_ENV, REACT_APP_PROCESS_ENV } from './stardardProcessEnvs'

const projectCode = STD_PROCESS_ENV.projectCode ?? REACT_APP_PROCESS_ENV.REACT_APP_PROJECT_CODE
const stage = STD_PROCESS_ENV.stage ?? REACT_APP_PROCESS_ENV.REACT_APP_DEPLOYMENT_STAGE
const accountId = STD_PROCESS_ENV.accountId ?? REACT_APP_PROCESS_ENV.REACT_APP_AWS_ACCOUNT_ID

export const CrossSystemProcessEnvs = { accountId, projectCode, stage }
